import config from "@config";

const currentTemplate = config.template.name || "base";

const routes = require(`../${currentTemplate}/store`);

export default routes.default;
